const hotelList = [
  {
    HotelName: 'Majestic Colonial',
    HotelLocation: 'Punta Cana',
    HotelId: 'M1',
    HotelCode: 'MCPC',
  },
  {
    HotelName: 'Majestic Elegance',
    HotelLocation: 'Punta Cana',
    HotelId: 'M2',
    HotelCode: 'MEPC',
  },
  {
    HotelName: 'Majestic Mirage',
    HotelLocation: 'Punta Cana',
    HotelId: 'M3',
    HotelCode: 'MMPC',
  },
  {
    HotelName: 'Majestic Elegance',
    HotelLocation: 'Costa Mujeres',
    HotelId: 'M4',
    HotelCode: 'MECM',
  },
];

export default hotelList;

// M1	String	Majestic Colonial Punta Cana
// M2	String	Majestic Elegance Punta Cana
// M3	String	Majestic Mirage Punta Cana
// M4	String	Majestic Elegance Costa Mujeres
